export const rem = size => `${size / 16}rem`;
